import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid, Row, Col } from 'react-flexbox-grid';
import BodyClassName from 'react-body-classname';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Spin from 'antd/lib/spin';
import { MajakIcon } from '../../../common/components';
import rules from '../../../common/rules/rules';

const FormItem = Form.Item;

@Form.create()
@translate()
export default class LandingPage extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    goToCalculatorDebtor: PropTypes.func.isRequired,
    goToCalculatorCreditor: PropTypes.func.isRequired,
    isSubscribing: PropTypes.bool.isRequired,
    submitNewsletter: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  onNewsletterSubmit = e => {
    const { form, submitNewsletter } = this.props;

    form.validateFields((err, formData) => {
      const { email } = formData;
      if (!err && email) {
        submitNewsletter(email);
        form.resetFields();
      }
    });
  };

  render() {
    const { form, goToCalculatorCreditor, goToCalculatorDebtor, isSubscribing, t } = this.props;
    const { getFieldDecorator } = form;

    return (
      <BodyClassName className="landing">
        <div className="landing-page-wrapper">
          <section className="top-section">
            <Grid>
              <Row center="xs">
                <Col xs={12} md={10}>
                  <h1>{t('Ľudia pre ľudí')}</h1>
                  <p>{t('Využite komunitné investovanie alebo požičiavanie.')}</p>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={10} md={8} className="buttons">
                  <Button type="primary" onClick={goToCalculatorDebtor} size="large">
                    {t('Chcem si požičať')}
                  </Button>
                  <Button type="danger" onClick={goToCalculatorCreditor} size="large">
                    {t('Chcem investovať')}
                  </Button>
                </Col>
              </Row>
            </Grid>
          </section>

          <section className="about">
            <Grid>
              <Row>
                <Col xs={12} md={4} mdOffset={1}>
                  <h2>{t('Výhodné Investície,')}</h2>
                  <h2>{t('Férové Pôžičky')}</h2>
                  <p>
                    {t(
                      'Ak nechcete, aby na Vás zarábali banky či nebankovky, požičajte si výhodnejšie priamo od ľudí, s ktorými vás spojí náš portál. Alebo požičiavajte priamo Vy a bez banky.'
                    )}
                  </p>
                  <br />
                  <p>
                    {t(
                      'Moderná, bezpečná a vo svete populárna forma investovania a pôžičky, ktorá stojí na transparentnosti, efektivite a ľudskosti.'
                    )}
                  </p>
                </Col>
                <Col xs={12} md={4} mdOffset={2} className="benefits">
                  <div className="benefit">
                    <MajakIcon type="transparentnost" />
                    <div className="text">
                      <h4>{t('Transparentnosť')}</h4>
                      <p>
                        {t(
                          'Vždy viete výšku Vašej pôžičky / investície a jej stav. Žiadne skryté poplatky.'
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="benefit">
                    <MajakIcon type="ludskost-o" />
                    <div className="text">
                      <h4>{t('Ľudskosť')}</h4>
                      <p>{t('Iba ľudia ľuďom a bez strachu, že prídete o svoj majetok.')}</p>
                    </div>
                  </div>
                  <div className="benefit">
                    <MajakIcon type="efektivnost" />
                    <div className="text">
                      <h4>{t('Efektívnosť')}</h4>
                      <p>
                        {t('Všetko vybavíte z pohodlia svojho domova. A nemusíte nikam chodiť.')}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Grid>
          </section>

          <section className="investment-types">
            <Grid>
              <Row>
                <Col xs={12} sm={6}>
                  <div className="debtor">
                    <div className="debtor-info">
                      <h3>{t('Prečo si požičať cez nás?')}</h3>
                      <ul>
                        <li>{t('Požičku si vyberiem sám.')}</li>
                        <li>{t('Výhodnejšie ako v banke alebo nebankovke.')}</li>
                        <li>{t('Bez skrytých podmienok a poplatkov.')}</li>
                        <li>{t('Môžem si požičať priamo z domu.')}</li>
                        <li>{t('Moderná, bezpečná a vo svete populárna forma pôžičky.')}</li>
                        <li>{t('Pôžička od ľudí ako ste Vy.')}</li>
                      </ul>
                    </div>
                    <Button type="primary" onClick={goToCalculatorDebtor} className="btn-block">
                      {t('Mám záujem o pôžičku')}
                    </Button>
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div className="creditor">
                    <div className="creditor-info">
                      <h3>{t('Prečo investovať cez nás?')}</h3>
                      <ul>
                        <li>{t('Obíďte banky a zarobte viac.')}</li>
                        <li>{t('Majte zisk Vy z Vašich peňazí a nie banky.')}</li>
                        <li>{t('Transparentné investície s úplnou kontrolou.')}</li>
                        <li>{t('Vyšší výnos ako pri uložených peniazoch v banke.')}</li>
                        <li>{t('Moderná, bezpečná a populárna forma investovania.')}</li>
                        <li>{t('Pomôžte ľuďom ako ste Vy.')}</li>
                      </ul>
                    </div>
                    <Button type="danger" onClick={goToCalculatorCreditor} className="btn-block">
                      {t('Mám záujem o investíciu')}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Grid>
          </section>

          <section className="newsletter">
            <Spin spinning={isSubscribing}>
              <Grid>
                <Row center="xs">
                  <Col xs={12} md={10}>
                    <h2>{t('Odoberajte novinky')}</h2>
                    <p>
                      {t(
                        'Chcete sa ako prvý dozvedieť o novinkách na Majak.sk? Vyplnte Váš e-mail a kliknite na Odoberať.'
                      )}
                    </p>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col xs={12} md={5} sm={6}>
                    <Form>
                      <FormItem>
                        {getFieldDecorator(`email`, {
                          rules: [rules.email],
                        })(
                          <Input size="large" onPressEnter={this.onNewsletterSubmit} type="email" />
                        )}
                      </FormItem>
                    </Form>
                  </Col>
                  <Col xs={12} md={2} sm={3}>
                    <Button type="primary" className="btn-block" onClick={this.onNewsletterSubmit}>
                      {t('Odoberať')}
                    </Button>
                  </Col>
                </Row>
              </Grid>
            </Spin>
          </section>
        </div>
      </BodyClassName>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/landing-page/components/LandingPage.js